// import router from "@/router";
// import { APIService } from "@/config/api-service-client.js";
import axios from "axios";

const getDefaultState = () => {
  return {
    isTestMode: sessionStorage.getItem("isTestMode") || false,
    status: null,
    errorStatus: null,

    selfRegUser: null,
    selfRegUserFound: null,
    selfRegUserErrorStatus: null,
    preferences: {},

    profile: null,
  };
};

export default {
  state: getDefaultState(),

  getters: {
    isTestMode: (state) => state.isTestMode,
    getSelfRegUser: (state) => state.selfRegUser,
    getSelfRegUserFound: (state) => state.selfRegUserFound,
    getPreferences: (state) => state.preferences,
    getSelfRegUserErrorStatus: (state) => state.selfRegUserErrorStatus,
    getUserStatus: (state) => state.status,
    getProfileType: (state) => state.profile,
  },

  actions: {
    async sendConfirmationCode(ctx, data) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;
      try {
        const resp = await axios.post(
          `/${client_name}/${context_key}/confirmation-code/send`,
          data
        );
        return resp.data;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async checkConfirmationCode(ctx, data) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;
      try {
        const resp = await axios.post(
          `/${client_name}/${context_key}/confirmation-code/check`,
          data
        );
        return resp.data;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async fetchSelfUserData(ctx, payload) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;
      try {
        const resp = await axios.get(
          `/${client_name}/${context_key}/users/email/${payload.email}`
        );
        ctx.commit("MUTATE_SELF_REG_USER", resp.data);
        return resp.data;
      } catch (e) {
        console.log("e", e);
        const status = e.response.data.status;
        ctx.commit("MUTATE_SELF_REG_USER_ERROR", {
          ...payload,
          status,
        });
        throw e;
      }
    },

    // 1- просто новый
    // 2 - новый пользователь с новым сервисом
    // 3 - для сущесствующего пользователя с существубщем сервисом создать доступ

    async createNewUser(ctx, newUser) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;
      const { profile, ...sendData } = newUser;
      try {
        const resp = await axios.post(
          `/${client_name}/${context_key}/users/${profile}`,
          sendData.user
        );
        ctx.commit("UPDATE_USER_DATA", resp.data);
        return resp.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },

    async createNewUserWithNewService(ctx, newUserWithNewService) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;
      const { profile, ...sendData } = newUserWithNewService;
      try {
        const resp = await axios.post(
          `/${client_name}/${context_key}/users/with-service/${profile}`,
          sendData.user
        );
        ctx.commit("UPDATE_USER_DATA", resp.data);
        return resp.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },

    async createNewUserAccess(ctx, payload) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;
      const { profile, user } = payload;
      try {
        const resp = await axios.post(
          `/${client_name}/${context_key}/users/access/${profile}`,
          user
        );
        return resp.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },

    async sendEmailNotification(ctx, data) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;
      const { profile, hasInfo, pharmacist } = data;

      const newService = ctx.getters.newService;
      const newEstablishment = ctx.getters.getNewEstablishment;
      const userFound = ctx.getters.getSelfRegUserFound;
      const user = ctx.getters.getSelfRegUser;

      const SEND_DATA = {
        intervant: user,
        pharmacist: hasInfo ? pharmacist : null,
        found: userFound,
        new_service: newService,
        new_organization: newEstablishment,
        profile: profile,
      };

      try {
        const resp = await axios.post(
          `/${client_name}/${context_key}/users/send-data-mail`,
          SEND_DATA
        );
        return resp.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
  },

  mutations: {
    RESET_REGISTRATION_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    UPDATE_USER_DATA: (state, data) => {
      state.selfRegUser = data;
    },
    MUTATE_SELF_REG_USER: (state, data) => {
      state.status = "success";
      state.selfRegUserFound = true;
      state.selfRegUser = data;
    },
    MUTATE_SELF_REG_USER_ERROR: (state, payload) => {
      state.status = "error";
      state.selfRegUserFound = false;
      const status = payload.status;
      if (status) state.selfRegUserErrorStatus = status;
      state.selfRegUser = { email: payload.email, phone: payload.phone };
    },
    UPDATE_PREFERENCES: (state, preferences) => {
      state.preferences = {
        ...state.preferences,
        ...preferences,
      };
    },
    UPDATE_PROFILE: (state, profile) => {
      state.profile = profile;
    },
  },
};
